import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';

// The app was previously a PWA (vite-plugin-pwa). We removed the service
// worker because its precache served a one-reload-stale shell after every
// deploy. Proactively unregister this app's lingering SW and drop its caches so
// already-installed clients stop being served the old app and pick up
// deploys immediately. (No-op for anyone who never installed it.)
if ('serviceWorker' in navigator) {
  const appScope = new URL(import.meta.env.BASE_URL, window.location.origin).href;
  void navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.filter((reg) => reg.scope.startsWith(appScope)).forEach((reg) => void reg.unregister());
  });
  if ('caches' in window) {
    void caches
      .keys()
      .then((keys) =>
        keys
          .filter((key) => key.includes('voice-leading-calculator') || key.startsWith('vlc:'))
          .forEach((key) => void caches.delete(key)),
      );
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
